<template>
    <div class="modal course-modal" style="display: block">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content p-2 p-md-4 p-lg-5">
                <div class="modal-body">
                    <button type="button" class="close-btn" @click="$emit('canceled')" aria-label="Close"
                            data-dismiss="modal"></button>

                    <div v-if="courseScheduleResponse && course_schedule" class="container">
                        <div class="label mb-3">{{ course_schedule.from | dateFormat('dddd MMMM D') }}</div>
                        <h2>{{ course.name }}</h2>

                        <div class="alert alert-warning" v-if="booking && booking.available_guest_accounts > 0">
                            <p>You have {{ booking.available_guest_accounts }} more guest account. We recommend to set
                                up guest's account before booking classes</p>
                            <a :href="booking.link" class="btn btn-warning">Set up guests' accounts</a>
                        </div>

                        <div class="alert alert-warning" v-if="course_schedule.is_available && availablePlacesCount < guests.length">
                            <div v-if="availablePlacesCount > 1">
                                Only {{ availablePlacesCount }} places are available
                            </div>
                            <div v-else>
                                Only 1 place is available
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-7 params  order-md-1 order-2">
                                <p v-if="course.short_description"
                                   class="font-size-up font-weight-bold"
                                   @click="showDescription = !showDescription">
                                    {{ course.short_description }}</p>
                                <div v-if="showDescription && course.description">
                                    <div v-html="course.description" class="font-size-up" @click="showDescription = false"></div>
                                    <button class="btn btn-sm btn-info" @click="showDescription = false">hide</button>
                                </div>
                                <div v-else>
                                    <button class="btn btn-sm btn-info" @click="showDescription = true">show description</button>
                                </div>
                                <div class="my-4">
                                    <div class="row my-1 my-md-2 param">
                                        <div class="col-3 key">
                                            Time
                                        </div>
                                        <div class="col-9 val">
                                            {{ course_schedule.from | dateFormat('h:mma') }} -
                                            {{ course_schedule.till | dateFormat('h:mma') }}
                                        </div>
                                    </div>
                                    <div class="row my-1 my-md-2 param" v-if="course.benefit">
                                        <div class="col-3 key">
                                            Benefit
                                        </div>
                                        <div class="col-9 val">
                                            {{ course.benefit }}
                                        </div>
                                    </div>
                                    <div class="row my-1 my-md-2 param" v-if="course_schedule.level">
                                        <div class="col-3 key">
                                            Intensity
                                        </div>
                                        <div class="col-9 val">
                                            {{ course_schedule.level }}
                                        </div>
                                    </div>
                                    <div class="row my-1 my-md-2 param" v-if="course_schedule.length">
                                        <div class="col-3 key">Length</div>
                                        <div class="col-9 val">{{ course_schedule.length }}</div>
                                    </div>
                                    <div class="row my-1 my-md-2 param" v-if="trainer">
                                        <div class="col-3 key">Instructor</div>
                                        <div class="col-9 val">{{ trainer.name }}</div>
                                    </div>
                                    <div class="row my-1 my-md-2 param" v-if="course_schedule.location">
                                        <div class="col-3 key">
                                            Location
                                        </div>
                                        <div class="col-9 val">
                                            {{ course_schedule.location }}
                                        </div>
                                    </div>
                                    <div class="row my-1 my-md-2 param" v-if="course.attire">
                                        <div class="col-3 key">
                                            Attire
                                        </div>
                                        <div class="col-9 val">
                                            {{ course.attire }}
                                        </div>
                                    </div>
                                    <div class="row my-1 my-md-2 param" v-if="course.notes">
                                        <div class="col-3 key">
                                            Notes
                                        </div>
                                        <div class="col-9 val">
                                            {{ course.notes }}
                                        </div>
                                    </div>
                                    <div class="row my-1 my-md-2 param" v-if="course_schedule.course_waits_count">
                                        <div class="col-3 key">
                                            Wait List
                                        </div>
                                        <div class="col-9 val">
                                            {{ course_schedule.course_waits_count | guestsInWaitList }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5 booking-block order-md-2 order-1">
                                <div class="guests p-1 p-md-3 mb-2" :class="{ booked: hasOrders() }"
                                     v-if="canAnyGuestBook()">
                                    <div class="font-size-up font-weight-bold">
                                        <span v-if="hasOrders()">You booked this class for</span>
                                        <span v-else>Book this class</span>
                                    </div>
                                    <div class="my-1 form-check guest" v-for="guest in guests">
                                        <input type="checkbox" :value="guest.id" v-model="selectedGuestsIds"
                                               :id="'guest' + guest.id" :disabled="canGuestBookProxy(guest) === false" >
                                        <label class="form-check-label" :for="'guest' + guest.id">{{
                                                guest.name
                                            }}</label>
                                        <div v-if="getOverlappedOrders(guest)"
                                             class="alert alert-warning small p-1 ml-3">
                                            overlaps with
                                            <div v-for="overlappedOrder in getOverlappedOrders(guest)">
                                                {{ overlappedOrder.from | dateFormat('h:mma') }} -
                                                {{ overlappedOrder.till | dateFormat('h:mma') }} at
                                                {{ overlappedOrder.course.name }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mt-3" v-if="availableToUpdateProxy()">
                                        <div v-if="hasOrders()">
                                            <button class="btn btn-link float-right" @click="submit">Update</button>
                                        </div>
                                        <div v-else>
                                            <button class="btn btn-block"
                                                    :class="[selectedGuestsIds.length === 0 || !cancellationPolicyAgreed ? 'btn-outline-secondary' : 'btn-success']"
                                                    :disabled="selectedGuestsIds.length === 0 || !cancellationPolicyAgreed"
                                                    @click="submit">Book now
                                            </button>
                                        </div>
                                    </div>

                                    <div class="clearfix"></div>

                                </div>
                                <div v-if="canAnyGuestWait()">
                                    <div class="alert alert-warning mb-2">
                                        This class has no available capacity. You can add yourself to the wait list.
                                        {{ course_schedule.course_waits_count | guestsInWaitList }} guests in the wait list.
                                    </div>
                                    <div class="guests p-1 p-md-3" :class="{ booked: hasWaits() }">

                                        <div class="font-size-up font-weight-bold">
                                            <span v-if="hasWaits()">You are in the wait list</span>
                                            <span v-else>Wait List</span>
                                        </div>
                                        <div class="my-1 form-check guest" v-for="guest in guests">
                                            <input type="checkbox" :value="guest.id" v-model="waitingGuestsIds"
                                                   :id="'guest' + guest.id" :disabled="!canGuestWait(guest)">
                                            <label class="form-check-label" :for="'guest' + guest.id">{{
                                                    guest.name
                                                }}</label>
                                            <div v-if="getOverlappedOrders(guest)"
                                                 class="alert alert-warning small p-1 ml-3">
                                                overlaps with
                                                <div v-for="overlappedOrder in getOverlappedOrders(guest)">
                                                    {{ overlappedOrder.from | dateFormat('h:mma') }} -
                                                    {{ overlappedOrder.till | dateFormat('h:mma') }} at
                                                    {{ overlappedOrder.course.name }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="mt-3">
                                            <div v-if="hasWaits()">
                                                <button class="btn btn-link float-right" @click="submit">Update</button>
                                            </div>
                                            <div v-else>
                                                <button class="btn btn-block"
                                                        :class="[waitingGuestsIds.length === 0 ? 'btn-secondary' : 'btn-success']"
                                                        :disabled="waitingGuestsIds.length === 0"
                                                        @click="submit">Wait
                                                </button>
                                            </div>
                                        </div>

                                        <div class="clearfix"></div>

                                    </div>

                                </div>

                                <div v-if="isFinished()" class="d-none">
                                    <div class="alert alert-danger">
                                        <i class="fa-solid fa-circle-exclamation"></i> This class already happened.
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>
                    <div v-else>
                        loading data, 1 second please
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>


<script>

export default {
    props: {
        courseScheduleResponse: Object,
    },
    data() {
        return {
            selectedGuestsIds: [],
            waitingGuestsIds: [],
            cancellationPolicyAgreed: true,
            warnings: [],
            showDescription: false,
            bookingBlockHeight: '0'
        };
    },
    mounted() {
        //console.log(this.courseScheduleResponse);
        //this.$refs.course.focus();
        this.updateSelectedGuestsIds();
        this.updateWaitingGuestsIds();
        // $('#cancellationPolicyPopover').popover({
        //     container: 'body'
        // })
    },
    methods: {
        updateSelectedGuestsIds: function () {
            for (let i = 0; i < this.guest_orders.length; i++) {
                if (this.guest_orders[i]) {
                    if (this.guest_orders[i].course_order) {
                        this.selectedGuestsIds.push(this.guest_orders[i].user.id);
                    }
                }
            }
        },
        updateWaitingGuestsIds: function () {
            for (let i = 0; i < this.waits.length; i++) {
                this.waitingGuestsIds.push(this.waits[i].user_id);
            }
        },
        getOrderForGuest: function (guest) {
            let guestId = guest.id;
            return _.find(this.courseScheduleResponse.course_schedule.guest_orders, function (v, k) {
                if (!v.user) {
                    return false;
                }
                return v.user.id === guestId;
            });
        },
        getWaitForGuest: function (guest) {
            let guestId = guest.id;
            return _.find(this.courseScheduleResponse.course_schedule.waits, function (v, k) {
                if (!v.user_id) {
                    return false;
                }
                return v.user_id === guestId;
            });
        },
        canGuestBookProxy: function (guest) {

            let result = false;

            result = this.canGuestBook(guest);

            //console.log('canGuestBookProxy', result);

            return result;

        },
        canGuestBook: function (guest) {
            let guestOrder = this.getOrderForGuest(guest);

            let availablePlacesCount = this.availablePlacesCount;

            if (availablePlacesCount < this.guests.length) {
                if (!_.find(this.selectedGuestsIds, function(o) { return o === guest.id; } )) {
                    if (this.selectedGuestsIds.length >= availablePlacesCount) {
                        //console.log('can NOT book because availablePlacesCount less then selected guest ids');
                        return false;
                    }
                }
            }

            if (!this.courseScheduleResponse.course_schedule.is_available) {
                if (guestOrder.is_editable) {
                    //console.log('can book because guestOrder is editable');
                    return true;
                }
                //console.log('can NOT book because course_schedule is not available');
                return false;
            }

            if (guestOrder.is_bookable) {
                //console.log('can book because guestOrder is bookable');
                return true;
            }

            if (guestOrder.is_editable) {
                //console.log('can book because guestOrder is editable');
                return true;
            }

            //console.log('can NOT book by default');
            //console.log(guestOrder);
            return false;
        },
        canAnyGuestBook: function () {
            let guestOrder = null;
            let guest = null;
            for (let i = 0; i < this.guests.length; i++) {
                guest = this.guests[i];
                guestOrder = this.getOrderForGuest(guest);
                if (guestOrder.is_bookable || guestOrder.is_editable || guestOrder.course_order) {
                    return true;
                }
            }

            return false;
        },
        canGuestWait: function (guest) {
            let guestOrder = this.getOrderForGuest(guest);
            if (guestOrder.is_waitable) {
                return true;
            }

            return false;
        },
        canAnyGuestWait: function () {
            let guestOrder = null;
            let guest = null;
            for (let i = 0; i < this.guests.length; i++) {
                guest = this.guests[i];
                if (!_.find(this.selectedGuestsIds, guest.id)) {
                    guestOrder = this.getOrderForGuest(guest);
                    if (guestOrder.is_waitable) {
                        return true;
                    }
                }
            }

            return false;
        },

        getOverlappedOrders: function (guest) {
            if (this.course_schedule.is_finished) {
                return false;
            }
            let guestOrder = this.getOrderForGuest(guest);
            if (!guestOrder.is_bookable) {
                if (!_.isUndefined(guestOrder.overlapped_orders)) {
                    return guestOrder.overlapped_orders;
                }
            }

            return false;
        },
        submit: function () {
            let data = this.getEventData();
            let guestsWithOrders = _.filter(this.courseScheduleResponse.course_schedule.guest_orders, function (v, k) {
                return v.course_order;
            })
            if (guestsWithOrders.length > 0 && data.book_user_ids.length < guestsWithOrders.length) {
                if (!this.course_schedule.is_cancelable) {
                    if (!confirm('The cancellation period for this class has already expired, canceling this class will result in a late cancellation/no show fee of $15 for any complimentary class or the full amount for any paid classes. Please contact our guest experience team at gx@civanacarefree.com if you have any further questions')) {
                        return false;
                    }
                }
            }
            this.$emit('submitted', data)
        },
        getEventData: function () {
            return {
                course_schedule_id: this.course_schedule.id,
                book_user_ids: this.selectedGuestsIds,
                booking_id: this.booking.id,
                wait_user_ids: this.waitingGuestsIds,
                hasOrders: this.hasOrders(),
                hasWaits: this.hasWaits(),
            };
        },
        availableToUpdateProxy: function () {
            let result = false;

            result = this.availableToUpdate();

            //console.log('availableToUpdate', result);

            return result;
        },
        availableToUpdate: function () {
            if (this.course_schedule.is_available) {
                //console.log('availableToUpdate because course_schedule is available');
                return true;
            }
            if (!this.course_schedule.is_editable) {
                //console.log('NOT availableToUpdate because course_schedule is not editable');
                return false;
            }
            let guestsWithOrders = _.filter(this.courseScheduleResponse.course_schedule.guest_orders, function (v, k) {
                return v.course_order;
            })
            if (guestsWithOrders.length > 0) {
                //console.log('availableToUpdate because has orders');
                return true;
            }

            return false;
        },
        hasOrders: function () {
            let guestsWithOrders = _.filter(this.courseScheduleResponse.course_schedule.guest_orders, function (v, k) {
                return v.course_order;
            })

            return guestsWithOrders.length > 0;
        },
        hasWaits: function () {
            return this.courseScheduleResponse.course_schedule.waits.length > 0;
        },
        isGuestWaiting: function (guest) {
            return this.courseScheduleResponse.course_schedule.waits.length > 0;
        },
        isFinished: function () {
            return this.courseScheduleResponse.course_schedule.is_finished;
        }
    },
    filters: {
        dateFormat: function (date, format) {
            return moment(date).format(format);
        },
        guestsInWaitList: function (number) {
            if (number > 7) {
                return '7+';
            }

            return number;
        },
    },
    computed: {
        availablePlacesCount: function () {
            return parseInt(this.courseScheduleResponse.course_schedule.available_places_count);
        },
        course: function () {
            return this.courseScheduleResponse.course_schedule.course;
        },
        booking: function () {
            return this.courseScheduleResponse.booking;
        },
        trainer: function () {
            if (this.courseScheduleResponse.course_schedule.trainer) {
                return this.courseScheduleResponse.course_schedule.trainer;
            }
            return this.course.trainer;
        },
        guests: function () {
            return this.courseScheduleResponse.booking.guests;
        },
        guest_orders: function () {
            return this.courseScheduleResponse.course_schedule.guest_orders;
        },
        course_schedule: function () {
            return this.courseScheduleResponse.course_schedule;
        },
        waits: function () {
            return this.courseScheduleResponse.course_schedule.waits;
        }
    }
}
</script>
